import { useSelector } from 'react-redux';

import { selectAssessmentReportsCountByStatus } from '../services/selectors';

export const useAssessmentReportsCountByStatus = () => useSelector(selectAssessmentReportsCountByStatus);
